export default {"src":"/_next/static/media/Youtube.92ee90f5.svg","height":29,"width":30,"blurWidth":0,"blurHeight":0};